import i18n from '@/config/i18n';
import { Vendor } from '@/model/vendor';
import { VendorFormData } from '@/model/vendor-form-data';
import { VendorSettingsPage } from '@/model/vendor-settings-page';
import vendorsService from '@/services/vendors.service';
import { Collection } from '@/store/common/collections';
import { createEntityActions } from '@/store/common/entities-actions';
import { createEntityGetters } from '@/store/common/entities-getters';
import {
  EntitiesState,
  getInitialEntityState,
} from '@/store/common/entities-state';
import { useUiStore } from '@/store/ui-store';
import { useUsersStore } from '@/store/users-store';
import cloneDeep from 'lodash-es/cloneDeep';
import { defineStore } from 'pinia';
import { reactive } from 'vue';

const newVendorBaseState: VendorFormData = {
  /*  name: 'Hair Piles',
  address: 'Ch. du Pole 2',
  zip: '1003',
  city: 'Lausanne',
  country: 'CH',
  email: 'michels@jmservices.ch',
  phone: '+41798600485',
  picture: '',
  public_name: 'Hair Piles',*/
  default_language: i18n.global.locale.value as string,
  /*  _translations: {
    fr: {
      description: '',
    },
  },*/
  employees: [
    {
      user: {
        /* email: 'jcquse@jmservices.ch',
        lastname: 'Gambit',
        firstname: '',
        mobile_phone: '+41796686841',
        gender: Gender.MALE,*/
      },
    },
  ],
};

const initialEntityState = reactive({
  ...getInitialEntityState<Vendor>(),
});
const state: EntitiesState<Vendor> & {
  form?: VendorFormData;
  smsCount?: number;
} = initialEntityState;
state.form = cloneDeep(newVendorBaseState) as VendorFormData;
state.smsCount = 0;

export const useVendorsStore = defineStore('vendors', {
  state: () => state,
  getters: {
    ...createEntityGetters<Vendor>(),
    getAllAsSelectOptions: (state) => {
      return state.entities.map((vendor: Vendor) => {
        return {
          label: vendor.public_name,
          value: vendor.id,
        };
      });
    },
  },
  actions: {
    ...createEntityActions<Vendor>(Collection.VENDORS, initialEntityState),
    async getUserVendor() {
      const userStore = useUsersStore();
      const data = await Promise.all([
        this.findOne(userStore.loggedInVendorId),
        vendorsService.getRemainingCredits(userStore.loggedInVendorId),
      ]);
      state.smsCount = data[1] ?? 0;
      this.form = {
        ...this.getById(userStore.loggedInVendorId),
      };
    },
    async findOneBySlug(slug: string) {
      try {
        this.fetching = true;
        this.failure = false;
        this.currentEntity = await vendorsService.getBySlug(slug);
        this.fetching = false;
      } catch (exception) {
        this.fetching = false;
        this.failure = true;
        useUiStore().alert(exception.message);
      }
      return this.currentEntity;
    },
    async edit(
      vendor: Partial<Vendor> | VendorFormData,
      validate: VendorSettingsPage,
      showSuccessToast = true,
    ) {
      this.saving = true;
      this.failure = false;
      try {
        const response = await vendorsService.edit(vendor, validate);
        this.saving = false;
        this.currentEntity = response;
        this.form = {
          ...response,
        };
        if (showSuccessToast) {
          useUiStore().alertSuccess(i18n.global.t('toast.changesSaved'));
        }
        this.validationErrors = {};
        return true;
      } catch (exception) {
        this.failure = true;
        this.saving = false;
        if (exception.errors !== undefined) {
          this.validationErrors = exception.errors;
        }
        useUiStore().alertValidationError(exception);
        return false;
      }
    },
    async revokingSlack(vendor: VendorFormData) {
      this.saving = true;
      this.failure = false;
      try {
        const response = await vendorsService.revokingSlack(vendor);
        this.validationErrors = {};
        this.saving = false;
        this.currentEntity = response;
      } catch (exception) {
        this.failure = true;
        this.saving = false;
        if (exception.errors !== undefined) {
          this.validationErrors = exception.errors;
        }
        useUiStore().alertValidationError(exception);
      }
    },
    async getUserVendorsList() {
      try {
        this.fetching = true;
        this.failure = false;
        this.entities = await vendorsService.userList();
        this.fetching = false;
      } catch (exception) {
        this.fetching = false;
        this.failure = true;
        useUiStore().alert(exception.message);
      }
    },
  },
});
